export default "__VITE_ASSET__ClJnUlPm__"